import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ReactModal from '../../../components/Modal';

const PREFIX = 'ai_tracking.onboarding';

/**
 * The one-time greeting that offers the setup flow to a user who has never finished a project.
 *
 * Skipping is a real answer, not a postponement to nag about: it is remembered for good, and the
 * checklist in the page header is what the user comes back to when they are ready. That is why
 * there is no "remind me later" -- the checklist already is the later.
 */
class WelcomeModal extends Component {
    render() {
        const { t, isOpen, onStart, onSkip } = this.props;

        return (
            <ReactModal
                modalState={isOpen}
                className="width-sm ai-tracking-modal onboarding-step onboarding-welcome-modal"
                onClose={onSkip}
            >
                <h3>{t(`${PREFIX}.welcome.header`)}</h3>
                <div className="ai-tracking-modal-body">
                    <div className="onboarding-welcome-text">{t(`${PREFIX}.welcome.text`)}</div>
                    <ol className="onboarding-welcome-steps">
                        <li>{t(`${PREFIX}.steps.brand`)}</li>
                        <li>{t(`${PREFIX}.steps.profile`)}</li>
                        <li>{t(`${PREFIX}.steps.prompts`)}</li>
                    </ol>
                </div>
                <div className="ai-tracking-modal-footer">
                    <button
                        type="button"
                        className="button button-filled button-primary width-sm btn"
                        onClick={onStart}
                    >
                        {t(`${PREFIX}.welcome.start`)}
                    </button>
                    <button
                        type="button"
                        className="button button-outline button-primary width-sm btn"
                        onClick={onSkip}
                    >
                        {t(`${PREFIX}.welcome.skip`)}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(WelcomeModal);
